.list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  border-top: 1px solid var(--rule);
}

.row {
  display: grid;
  grid-template-columns: 48px 1fr auto;
  align-items: center;
  gap: var(--space-2);
  min-height: 48px;
  padding: var(--space-1) var(--space-3);
  border-bottom: 1px solid var(--rule);
  cursor: default;
}

.row[data-hovered] {
  border-radius: var(--radius-control);
  background: var(--brand-tint);
}

/* The selected patient: a rounded fill in the strong primary tint (ADR 0028). */
.row[data-selected] {
  border-radius: var(--radius-control);
  background: var(--brand-tint-strong);
}

.row[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: calc(-1 * var(--focus-offset));
}

.ticket {
  font: var(--t-body);
  font-family: var(--font-id);
}

.who {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.name {
  overflow: hidden;
  font: var(--t-body-strong);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.details {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  color: var(--graphite);
  font: var(--t-small);
}

.state {
  padding: 0 var(--space-1);
  border-radius: var(--radius-tag);
  background: var(--brand);
  color: var(--on-brand);
  font: var(--t-micro);
}

.marker {
  padding: 0 var(--space-1);
  border: 1px solid var(--status-warning-fg);
  border-radius: var(--radius-tag);
  background: var(--status-warning-bg);
  color: var(--status-warning-fg);
  font: var(--t-micro);
}

.wait {
  font: var(--t-body);
  font-variant-numeric: tabular-nums;
  text-align: right;
  white-space: nowrap;
}
